import { render, staticRenderFns } from "./SettingUpKolibri.vue?vue&type=template&id=3eb36c53&scoped=true"
import script from "./SettingUpKolibri.vue?vue&type=script&lang=js"
export * from "./SettingUpKolibri.vue?vue&type=script&lang=js"
import style0 from "./SettingUpKolibri.vue?vue&type=style&index=0&id=3eb36c53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb36c53",
  null
  
)

export default component.exports